import { __values } from "tslib";
var defaultSlot = Symbol('channel');
/**
 *
 * A channel is a container of promises.
 *
 * Every promise has a unique name which is produced
 * by applying the mapper function to incoming event.
 *
 * The promise can be picked by it's name.
 * If the promise is not created (which means the event
 * is not received), a pending promise is created and will
 * be resolved when a specific event is received.
 *
 * @param mapper
 * @returns
 */
function channel(mapper) {
    if (mapper === void 0) { mapper = function () { return defaultSlot; }; }
    var closeErr;
    var promiseSlots = new Map();
    var promiseControls = new Map();
    function resolve(key, event) {
        var _a;
        (_a = promiseControls.get(key)) === null || _a === void 0 ? void 0 : _a.resolve(event);
        promiseControls.delete(key);
    }
    function reject(key, err) {
        var _a;
        (_a = promiseControls.get(key)) === null || _a === void 0 ? void 0 : _a.reject(err);
        promiseControls.delete(key);
    }
    function pick(key) {
        if (key === void 0) { key = defaultSlot; }
        if (closeErr) {
            return Promise.reject(closeErr);
        }
        if (!promiseSlots.has(key)) {
            promiseSlots.set(key, new Promise(function (resolve, reject) {
                promiseControls.set(key, { resolve: resolve, reject: reject });
            }));
        }
        return promiseSlots.get(key);
    }
    function put(event, key) {
        if (key === void 0) { key = defaultSlot; }
        if (promiseControls.has(key)) {
            resolve(key, event);
        }
        else {
            promiseSlots.set(key, Promise.resolve(event));
        }
    }
    function close(err, forceCleanup) {
        var e_1, _a;
        if (forceCleanup === void 0) { forceCleanup = false; }
        closeErr = err;
        try {
            for (var _b = __values(promiseControls.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                reject(key, err);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (forceCleanup) {
            clear();
        }
    }
    function clear() {
        promiseSlots.clear();
        promiseControls.clear();
    }
    function open() {
        closeErr = undefined;
    }
    function send(event) {
        if (closeErr)
            return;
        put(event, mapper(event));
    }
    return { send: send, pick: pick, open: open, close: close };
}
export default channel;
//# sourceMappingURL=channel.js.map